export type ThinkingEffort = 'minimal' | 'quick' | 'balanced' | 'maximum';

export const THINKING_EFFORTS: readonly ThinkingEffort[] = [
  'minimal',
  'quick',
  'balanced',
  'maximum',
];

export const DEFAULT_THINKING_EFFORT: ThinkingEffort = 'maximum';

type ThinkingEffortCopy = {
  label: string;
  hint: string;
  caption: string;
};

// No level mentions a duration: how long an answer takes depends on the question, so the copy
// only ever speaks about how much thinking is used.
export const THINKING_EFFORT_COPY: Record<ThinkingEffort, ThinkingEffortCopy> = {
  minimal: {
    label: 'Minimal',
    hint: 'least thinking',
    caption: 'Answers rapidly, more prone to mistakes and miscalculations.',
  },
  quick: {
    label: 'Quick',
    hint: 'less thinking',
    caption:
      'One pass, no re-checking. Less accurate than maximum, and worth it only when the answer is easy to verify yourself.',
  },
  balanced: {
    label: 'Balanced',
    hint: 'more thinking',
    caption:
      'Works through the numbers but skips some of its own checking. A little less accurate than maximum.',
  },
  maximum: {
    label: 'Maximum',
    hint: 'most thinking',
    caption:
      'Checks every figure and its own working. The most accurate answer Siesta can give, and the default.',
  },
};
